import { FC } from "react";
import { OptionProps, components } from "react-select";

import { MutedDarkText } from "shared/styles";
import { StyledValue } from "../styles";

export const TimezoneOption: FC<OptionProps<any, false>> = ({ children, ...props }) => {
  return (
    <components.Option {...props}>
      <StyledValue>
        <span>{children}</span>
        <MutedDarkText>{props.data.utc}</MutedDarkText>
      </StyledValue>
    </components.Option>
  );
};
